// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"functions"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 4H5V4.5L13.8667 12L5 19.5V20H19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FunctionsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'functions',
    ref,
    icon: element,
  },
));

FunctionsIcon.displayName = 'FunctionsIcon';

export default FunctionsIcon;
